function initializeHeroVideo(root) {
  const video = root.querySelector('video[data-rs-hero-video]');
  if (!video || video.dataset.rsPlaybackInitialized) return;
  video.dataset.rsPlaybackInitialized = 'true';
  video.muted = true;
  video.defaultMuted = true;
  video.volume = 0;
  video.autoplay = true;
  video.loop = true;
  video.playsInline = true;
  video.setAttribute('muted', '');
  video.setAttribute('playsinline', '');
  video.setAttribute('webkit-playsinline', '');
  let disposed = false;
  let pending = false;
  let retryTimer;
  const listeners = [];
  const isVisible = () => {
    const bounds = video.getBoundingClientRect();
    return !document.hidden && bounds.bottom > 0 && bounds.top < window.innerHeight && bounds.right > 0 && bounds.left < window.innerWidth;
  };
  const resume = () => {
    if (disposed || pending || !video.paused || !isVisible() || video.error) return;
    video.muted = true;
    pending = true;
    try {
      const attempt = video.play();
      if (attempt && typeof attempt.then === 'function') {
        attempt.catch(() => {}).finally(() => { pending = false; });
      } else pending = false;
    } catch { pending = false; }
  };
  const listen = (target, name, handler) => {
    target.addEventListener(name, handler, { passive: true });
    listeners.push(() => target.removeEventListener(name, handler));
  };
  ['loadeddata', 'canplay', 'ended'].forEach(name => listen(video, name, resume));
  listen(video, 'pause', () => {
    clearTimeout(retryTimer);
    retryTimer = setTimeout(resume, 250);
  });
  listen(document, 'visibilitychange', resume);
  listen(window, 'pageshow', resume);
  listen(window, 'focus', resume);
  listen(document, 'touchstart', resume);
  listen(document, 'pointerdown', resume);
  let observer;
  if (typeof IntersectionObserver !== 'undefined') {
    observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) resume();
    }, { threshold: 0.01 });
    observer.observe(video);
  } else listen(window, 'scroll', resume);
  resume();
  return () => {
    disposed = true;
    clearTimeout(retryTimer);
    listeners.forEach(remove => remove());
    if (observer) observer.disconnect();
    delete video.dataset.rsPlaybackInitialized;
  };
}

if (typeof document !== 'undefined') {
  const heroVideoCleanup = new WeakMap();
  const initialize = root => {
    const cleanup = initializeHeroVideo(root);
    if (cleanup) heroVideoCleanup.set(root, cleanup);
  };
  document.querySelectorAll('[data-rs-home]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => {
    const root = event.target.querySelector('[data-rs-home]');
    if (root) initialize(root);
  });
  document.addEventListener('shopify:section:unload', event => {
    const root = event.target.querySelector('[data-rs-home]');
    const cleanup = root && heroVideoCleanup.get(root);
    if (cleanup) cleanup();
  });
}
if (typeof module !== 'undefined') module.exports = { initializeHeroVideo };
